<template>
  <div>
    
    <top-navbar />

    <div v-if="isLoading || isLoading2" class="progress-popup-overlay">
      <div class="progress-popup-card">
        <div class="progress-loader-percent">{{ isLoading2 ? loadingProgress2 : loadingProgress }}%</div>
        <div class="progress-loader-track">
          <div
            class="progress-loader-fill"
            :style="{ width: (isLoading2 ? loadingProgress2 : loadingProgress) + '%' }"
          ></div>
        </div>
        <div class="progress-loader-label">{{ isLoading2 ? 'Loading files...' : 'Searching data...' }}</div>
      </div>
    </div>

    

    <div class="mb-5 " >

      <h6 class="manage-boder pt-2 font1 decoration" >
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3">
          <i class="fa fa-angle-right"></i>
        </span>
        <span class="decoration">CAMO</span>
        <span class="pfimg3">
          <i class="fa fa-angle-right"></i>
        </span>
        Search
      </h6>

      <div class="container-fluid" style="padding-bottom: 10px;">
        <div class=" bdr-rad2 mt-1  p-2" >
          <div class="" >
  
  
            <!-- <button class="btn btn-sm btn-outline-success mt-3 bdr-rad" @click="openSaveData">
              Show Saved Data
            </button> -->
            <!-- SEARCH -->
            <div class="search-container">


           

              <div class="row">
                  <label class="custom-label" style="font-size: small;">Folder Location</label>
                <div class="col-md-8">
                <div class="form-group">

             
              <input
                v-model="location2"
                type="text"
                class="form-control bdr-rad mb-1"
                placeholder="Folder Location"
              />
              </div>

                </div>
                <div class="col-md-4">
              <button
                @click="fileacess"
                class="btn btn-sm btn-outline-primary mb-1  bdr-rad"
              >
                Load
              </button>
              <button
                @click="Clear"
                class="btn btn-sm btn-outline-primary mb-1 ms-1  bdr-rad"
              >
                Clear
              </button>

                </div>


              </div>
<div v-if="!isLoading2" class="form-group">
  <label class="custom-label" style="font-size: small;">{{ subFolder1Label }}</label>
  <select v-model="selectedFolder" class="form-control mb-1 form-field-width" @change="loadSubFolders2">
    <option value="">-- Select Folder --</option>
    <option
      v-for="(f, i) in folders"
      :key="i"
      :value="f"
      :style="{
        fontWeight: f.split('/').length === 1 ? 'bold' : 'normal',
        paddingLeft: (f.split('/').length - 1) * 10 + 'px'
      }"
    >
      {{ f }}
    </option>
  </select>
</div>

<div class="form-group" v-if="subfolders2.length">
  <label class="custom-label" style="font-size: small;">{{ subFolder2Label }}</label>
  <select v-model="selectedSubFolder2" class="form-control mb-1 form-field-width" @change="loadFiles">
    <option value="">-- Select Subfolder --</option>
    <option
      v-for="(f, i) in subfolders2"
      :key="i"
      :value="f"
    >
      {{ f }}
    </option>
  </select>
</div>



<div class="form-group">
  <label class="custom-label" style="font-size: small;">Select Files</label>

  <div
    v-for="(file, index) in files"
    :key="index"
    class="form-check"
  >
    <input
      type="checkbox"
      class="form-check-input"
      :id="'file_'+index"
      :value="file"
      v-model="selectedFiles"
      @change="loadSelectedFileRecordCount"
    />

    <label class="form-check-label">
      {{ file }}
    </label>
  </div>
</div>



<div class="form-group" v-if="selectedFiles.length">
  <label class="custom-label" style="font-size: small;">
    Selected File List ({{ isCountingRecords ? 'Counting records...' : selectedFileRecordCount + ' records' }})
  </label>

  <ul class="list-group bdr-rad form-field-width">
    <li
      class="list-group-item py-1"
      v-for="(file,index) in selectedFiles"
      :key="index"
    >
      {{ file }}
    </li>
  </ul>
</div>



<div class="form-group">
    <label class="custom-label" style="font-size: small;">Search Criteria</label>
              <input
                v-model="keyword"
                type="text"
                class="form-control input5 input6 bdr-rad form-field-width"
                placeholder="Search keyword..."
              />
               <!-- <input
                v-model="keyword2"
                type="text"
                class="form-control input5 input6 bdr-rad mt-1"
                placeholder="search natural language"
              /> -->



              </div>

              <button
                @click="search"
                class="btn btn-sm btn-outline-primary mb-1 mt-1 bdr-rad"
              >
                Search
              </button>

              <!-- RESULTS -->
           <div v-if="!isLoading">
  <div
    v-for="(group, index) in groupedResults"
    :key="index"
    class="matched-table mt-3"
  >
 <div class="mb-2">
  Airplane(CVN): {{ getDisplayCvn(group.header_info) }}<br>
  LN: {{ getDisplayLn(group.header_info) }}<br>
  MSN: {{ getDisplayMsn(group.header_info) }}<br>
  Reg: {{ getDisplayReg(group.header_info) }}<br>
   <strong>{{ group.header_info.title }}</strong><br>
 {{ group.file || '-' }} - Page {{ group.page || '-' }}

</div>
  <div class="table-responsive">
    <table
      class="table table-hover table-sm table-borderless mt-2 table-responsive"
      style="font-size: small;"
    >
      <!-- TABLE HEADER (ONLY ONCE) -->
      <thead class="background_color2">
        <tr class="custom-label2">
            <th>Select</th>
          <th
            v-for="(h, j) in group.table_header"
            :key="j"
          >
            {{ h }}
          </th>
           
        </tr>
      </thead>

      <!-- MULTIPLE ROWS -->
     <tbody>
  <tr
    v-for="(row, rIndex) in group.rows"
    :key="rIndex"
  >
   <td>
      <input
  type="checkbox"
  v-model="selectedRows"
  :value="{
    file: group.file,
    page: group.page,
    headers: group.table_header,
    row: row,
    header_info: group.header_info || {}
  }"
/>
    </td>
   <td v-for="(header, cIndex) in group.table_header" :key="cIndex">
  {{ row[cIndex] }}   {{ row[header] }}
</td>




  </tr>
</tbody>

    </table>
    </div>
  </div>
<button
  class="btn  mt-3"
  @click="generateExcel"
   style="cursor: pointer;"
  :disabled="!selectedRows.length"
>
<img
      
     
      src="../../../public/img/excel.png"
      width="52px"
      alt="Evenware Logo"
    />
</button>

<button class="btn btn-sm btn-outline-success mt-3 bdr-rad" @click="openSavePopup">
  Save to Data
</button>

<div v-if="showSavePopup" class="popup-overlay">
  <div class="popup-card" style="width:400px; padding:20px;">
    
    <h5>Enter File Name</h5>

    <input
      v-model="masterName"
      type="text"
      class="form-control mb-3"
      placeholder="Enter File Name"
    />

    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary mr-2" @click="closeSavePopup">
        Cancel
      </button>

      <button class="btn btn-primary" @click="confirmSave">
        Save
      </button>
    </div>

  </div>
</div>

  <p v-if="searched && !groupedResults.length" class="mt-3">
    No results found.
  </p>
</div>
            </div>

          </div>

      
         
        </div>
            
      </div>
  
    </div>
   <br>

    <content-footer />
    
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  data() {
   return {
    location: "",            // Main folder URL
    location2: "",            // Main folder URL
    folders: [],             // First-level folders
    subfolders2: [],         // Subfolders of selected folder
    selectedFolder: "",
    selectedSubFolder2: "",
    files: [],
    selectedFiles: [],
    selectedFileRecordCount: 0,
    isCountingRecords: false,
    selectedRows: [],
     results: [],
    keyword: "",
    keyword2: "",
    isLoading: false,
    loadingProgress: 0,
    loadingProgressTimer: null,
      showSavePopup: false,
  masterName: "",
    isLoading2: false,
    loadingProgress2: 0,
    loadingProgressTimer2: null,
    searched: false,
    userid: authService.isUserid(),
  };
  },

computed: {
 groupedResults() {

  const map = {};

  this.results.forEach((r) => {

    const page = r.page || r.sheet || "";   // ✅ safe fallback

    const key = `${r.file}_${page}`;

    if (!map[key]) {
      map[key] = {
        file: r.file || "",
        page: page,
        table_header: r.table_header || [],
        header_info: r.header_info || {},
        rows: [],
      };
    }

    if (r.matched_row && Array.isArray(r.matched_row)) {
      r.matched_row.forEach(row => {
        map[key].rows.push(row);
      });
    }

  });

  return Object.values(map);

},

 subFolder1Label() {
  return `Sub Folder 1 (${this.folders.length} folders)`;
 },

 subFolder2Label() {
  return `Sub Folder 2 (${this.subfolders2.length} folders)`;
 },

},

 components :{
          
            ContentFooter,
            TopNavbar,
           
        },


 mounted() {
  this.logVisitAction("View", "Opened PDF Create 7 page");
 },

 beforeUnmount() {
  this.stopProgress("search");
  this.stopProgress("files");
 },


  methods: {
  startProgress(type) {
    const timerKey = type === "search" ? "loadingProgressTimer" : "loadingProgressTimer2";
    const valueKey = type === "search" ? "loadingProgress" : "loadingProgress2";
    const profile = type === "search"
      ? [
          { until: 45, step: 5, delay: 900 },
          { until: 75, step: 3, delay: 1200 },
          { until: 90, step: 2, delay: 1500 },
          { until: 95, step: 1, delay: 2500 }
        ]
      : [
          { until: 35, step: 3, delay: 2500 },
          { until: 65, step: 2, delay: 3000 },
          { until: 85, step: 2, delay: 3500 },
          { until: 93, step: 1, delay: 4500 }
        ];

    this.stopProgress(type);
    this[valueKey] = 0;

    const tick = () => {
      const current = this[valueKey];
      const stage = profile.find((item) => current < item.until);

      if (!stage) {
        return;
      }

      this[valueKey] = Math.min(stage.until, current + stage.step);
      this[timerKey] = window.setTimeout(tick, stage.delay);
    };

    this[timerKey] = window.setTimeout(tick, profile[0].delay);
  },

  stopProgress(type) {
    const timerKey = type === "search" ? "loadingProgressTimer" : "loadingProgressTimer2";
    const valueKey = type === "search" ? "loadingProgress" : "loadingProgress2";

    if (this[timerKey]) {
      clearTimeout(this[timerKey]);
      this[timerKey] = null;
    }

    this[valueKey] = 100;
    window.setTimeout(() => {
      this[valueKey] = 0;
    }, 300);
  },

  sanitizeHeaderValue(value, removeLabels = []) {
    let cleaned = (value || "").toString().trim();

    removeLabels.forEach((label) => {
      const regex = new RegExp(`\\s*${label}\\s*:?\\s*.*$`, "i");
      cleaned = cleaned.replace(regex, "");
    });

    cleaned = cleaned.trim();
    return cleaned || "-";
  },

  getDisplayLn(headerInfo = {}) {
    const lnValue = headerInfo.ln || headerInfo.line_number || "";
    return this.sanitizeHeaderValue(lnValue, ["MSN", "CVN", "Reg"]);
  },

  getDisplayMsn(headerInfo = {}) {
    const explicitMsn = this.sanitizeHeaderValue(headerInfo.msn || "", ["CVN", "Reg"]);
    if (explicitMsn !== "-") {
      return explicitMsn.replace(/^-+/, "").trim() || "-";
    }

    const lineValue = (headerInfo.ln || headerInfo.line_number || "").toString();
    const match = lineValue.match(/MSN\s*:?\s*([A-Z0-9-]+)/i);
    return match ? match[1].replace(/^-+/, "").trim() : "-";
  },

  getDisplayCvn(headerInfo = {}) {
    return this.sanitizeHeaderValue(headerInfo.cvn || headerInfo.airplane_id || "", ["MSN", "Reg"]);
  },

  getDisplayReg(headerInfo = {}) {
    return this.sanitizeHeaderValue(headerInfo.reg || "", ["MSN", "CVN"]);
  },

  async logVisitAction(action, summary, extraDetails = {}) {
    if (!this.userid) {
      return;
    }

    try {
      await axios.post(
        "https://demo-dev.evenware.com/DEMO_VUEJS/web/api/user/logvisitaction",
        {
          userid: this.userid,
          session_token: authService.isLoggedIn(),
          action,
          route: "/pdf/create7",
          file_name: this.selectedFiles.join(", "),
          summary,
          details: {
            folder_location: this.location2,
            selected_folder: this.selectedFolder,
            selected_sub_folder: this.selectedSubFolder2,
            selected_files: this.selectedFiles,
            keyword: this.keyword,
            natural_keyword: this.keyword2,
            result_count: this.results.length,
            selected_row_count: this.selectedRows.length,
            ...extraDetails
          }
        },
        {
          headers: {
            Authorization: "Bearer " + authService.isLoggedIn(),
            "Content-type": "application/json"
          }
        }
      );
    } catch (error) {
      console.log(error.response || error);
    }
  },

   async openSaveData(){
        this.$router.push('/pdf/index2?id='+1);
      },


openSavePopup() {
  if (!this.selectedRows.length) {
    alert("Select rows first");
    return;
  }
  this.showSavePopup = true;
},

closeSavePopup() {
  this.showSavePopup = false;
  this.masterName = "";
},


confirmSave() {

  if (!this.masterName) {
    alert("Please enter name");
    return;
  }

  const payload = {
    name: this.masterName,
    status: 1,
    created_by: 1,
    rows: this.selectedRows
  };

  axios.post(
    "https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/savemaintenance",
    payload
  )
  .then(res => {
    this.logVisitAction(
      "Save",
      "Saved maintenance data from PDF Create 7",
      {
        master_name: this.masterName,
        saved_rows: this.selectedRows.length
      }
    );
    alert("Saved successfully");
     this.Cleardata();
    console.log(res);

    // Reset everything
    this.masterName = "";
    this.selectedRows = [];
    this.showSavePopup = false;
  })
  .catch(err => {
    console.error(err);
  });
},
  
Cleardata(){
  axios.get("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/directorycontentsdelete", {
      
      
    }).then(res => {
      console.log(res);
      
    });
     window.location.reload();
},
Clear() {
    this.Cleardata();
    

},


 fileacess() {
  this.isLoading2 = true;
  this.startProgress("files");
  console.log('file access')
    axios.post("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/syncaircraftfiles",{location2:this.location2}, {
      
      
    }).then(res => {
      console.log(res.data);
      if(res.data.status=='success'){
        this.logVisitAction("Load", "Loaded aircraft files location", {
          loaded_location: this.location2
        });
        this.Loaddata();
      }
    });
 },


 async Loaddata() {
  this.isLoading2 = true;

  

    this.folders = [];
    this.files = [];
    this.selectedFolder = "";
    this.selectedSubFolder2 = "";
    this.subfolders2 = [];

    if (this.location2) {
      let cleanedLocation = this.location2
        .replace(/^https?:\/\/[^/]+\/(DEMO_VUEJS\/web\/)?/, '')
        .replace(/^\/+/, '')
        .replace(/\/+$/, '');

      this.location = 'aircraftfile';
      console.log(this.location);
    }

    // ✅ WAIT 20 SECONDS HERE
    // await new Promise(resolve => setTimeout(resolve, 10000));

    try {
      const res = await axios.get(
        "https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/aircraftfiles",
        { params: { location: this.location } }
      );

      if (res.data.error) {
        alert(res.data.error);
        this.isLoading2 = false;
        this.stopProgress("files");
        return;
      }

      console.log(res);
      this.folders = res.data.folders;
      this.files = res.data.files;

    } catch (error) {
      console.error(error);
    }

    this.isLoading2 = false;
    this.stopProgress("files");
  
},


  // Load 2nd-level subfolders when a folder is selected
  loadSubFolders2() {
  // Clear previous subfolder & files
  this.subfolders2 = [];
  this.selectedSubFolder2 = "";
  this.files = [];
  this.selectedFiles = [];
  this.selectedFileRecordCount = 0;

  if (!this.selectedFolder) return;

  // Construct full path to first-level folder
  const folderPath = this.location + '/' + this.selectedFolder;

  axios.get("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/folderlist", {
    params: { location: folderPath }
  })
  .then(res => {
    console.log(res);
    if (res.data.error) {
      alert(res.data.error);
      return;
    }

    // If there are subfolders, show them in the Sub Folders 2 dropdown
    if (res.data.folders && res.data.folders.length > 0) {
      this.subfolders2 = res.data.folders;
    } else {
      // No subfolders → load files directly
      console.log(folderPath);
      this.loadFilesFromFolder(this.selectedFolder);
    }
  });
},


  // Load files from selected subfolder (2nd-level)
  loadFilesFromFolder(folderPath) {
    this.files = [];
    this.selectedFiles = [];
    this.selectedFileRecordCount = 0;

    axios.get("https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/filelist", {
      params: { folder: folderPath }
      
    }).then(res => {
      console.log(res);
      if (res.data.error) {
        alert(res.data.error);
        return;
      }

      this.files = res.data.files || [];
    
    });
  },

  async loadSelectedFileRecordCount() {
    await this.$nextTick();

    if (!this.selectedFiles.length) {
      this.selectedFileRecordCount = 0;
      return;
    }

    let folderPath = this.selectedFolder;
    if (this.selectedSubFolder2) {
      folderPath += '/' + this.selectedSubFolder2;
    }

    this.isCountingRecords = true;

    try {
      const res = await axios.post('https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/pdftablerecordcount', {
        folder: folderPath,
        files: this.selectedFiles,
      });

      this.selectedFileRecordCount = Number(res.data.total_records) || 0;
    } catch (error) {
      console.error('Unable to count selected PDF records', error);
      this.selectedFileRecordCount = 0;
    } finally {
      this.isCountingRecords = false;
    }
  },
 
  loadFiles() {
    if (!this.selectedSubFolder2) return;
    const folderPath = this.selectedFolder + '/' + this.selectedSubFolder2;
    this.loadFilesFromFolder(folderPath);
  },

generateExcel() {
  if (!this.selectedRows.length) {
    alert("Select rows first");
    return;
  }

  const groups = {};

  // GROUP DATA BY FILE + PAGE
  this.selectedRows.forEach(item => {
    const key = item.file + "_" + item.page;

    if (!groups[key]) {
      groups[key] = {
        file: item.file,
        page: item.page,
        headers: item.headers,
        header_info: item.header_info || {},
        rows: []
      };
    }

    groups[key].rows.push(item.row);
  });

  const excelData = [];
  const headerRowIndexes = []; // store indexes of table headers for styling

  Object.values(groups).forEach(group => {
    const info = group.header_info;

    // 1️⃣ Header info rows (Title, Line, Aircraft, File)
    excelData.push([`Title: ${info.title || '-'}`]);
    excelData.push([`Line: ${info.line_number || '-'}`]);
    excelData.push([`Aircraft: ${info.airplane_id || '-'}`]);
    excelData.push([`File: ${group.file || '-'} - Page ${group.page || '-'}`]);
    excelData.push([]); // empty row before table

    // 2️⃣ Table headers
    headerRowIndexes.push(excelData.length); // save index BEFORE pushing
    excelData.push(group.headers);

    // 3️⃣ Table rows
    group.rows.forEach(row => {
      const rowData = group.headers.map((header, index) => {
        if (row) {
          if (Array.isArray(row)) {
            return row[index] || "";
          } else if (typeof row === "object") {
            return row[header] || "";
          }
        }
        return "";
      });
      excelData.push(rowData);
    });

    // 4️⃣ Empty rows between tables
    excelData.push([]);
    excelData.push([]);
  });

  // CREATE WORKSHEET
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);

  // =============================
  // HEADER STYLE APPLY
  // =============================
  headerRowIndexes.forEach(rowIndex => {
    const headers = excelData[rowIndex];
    headers.forEach((h, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
      if (!worksheet[cellAddress]) return;

      worksheet[cellAddress].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "828282" } },
        alignment: { horizontal: "center" }
      };
    });
  });

  // Style header info rows (bold)
  for (let r = 0; r < excelData.length; r++) {
    const row = excelData[r];
    if (
      row.length === 1 &&
      row[0] && // ✅ safe check
      (row[0].includes("Title:") ||
        row[0].includes("Line:") ||
        row[0].includes("Aircraft:") ||
        row[0].includes("File:"))
    ) {
      const cellAddress = XLSX.utils.encode_cell({ r, c: 0 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = { font: { bold: true } };
      }
    }
  }

  // Column width auto (optional)
  worksheet["!cols"] = [{ wch: 30 }, { wch: 60 }, { wch: 25 }, { wch: 20 }];

  // CREATE WORKBOOK AND EXPORT
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance");

  const wbout = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true
  });

  const blob = new Blob([wbout], { type: "application/octet-stream" });
  saveAs(blob, "maintenance_results.xlsx");
},





  search() {


  
  if (!this.selectedFiles.length || !this.keyword && !this.keyword2) {
    alert("Select folder, file(s), and enter keyword");
    return;
  }

  let folderPath = this.selectedFolder;

if (this.selectedSubFolder2) {
  folderPath += '/' + this.selectedSubFolder2;
}

  this.isLoading = true;
  this.startProgress("search");
  this.results = [];

  axios.post(
    "https://demo-dev.evenware.com/DEMO_VUEJS/web/api/mproduct/indexsearch2",
    {
      location: this.location,
      keyword: this.keyword,
      keyword2: this.keyword2,
     folder: folderPath, 
      files: this.selectedFiles   // 👈 array
    }
  )
  .then(res => {;
    console.log(res)
    console.log(JSON.stringify(res))
    this.results = res.data;
    this.searched = true;
    this.logVisitAction(
      "Search",
      `Searched PDF Create 7 and found ${this.results.length} result rows`,
      {
        result_groups: this.groupedResults.length
      }
    );
  })
  .finally(() => {
    this.isLoading = false;
    this.stopProgress("search");
  });
},



  },
};
</script>

<style scoped>
.search-container {
  padding: 20px;
}

.form-field-width {
  width: 66%;
}

@media (max-width: 767.98px) {
  .form-field-width {
    width: 100%;
  }
}

.progress-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.progress-popup-card {
  min-width: 300px;
  max-width: 380px;
  width: calc(100% - 32px);
  padding: 20px 22px;
  border: 1px solid #d8e5ff;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(15, 77, 170, 0.16);
  text-align: center;
}

.progress-loader-card {
  min-width: 280px;
  max-width: 360px;
  width: 100%;
  padding: 16px 18px;
  border: 1px solid #d8e5ff;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
  box-shadow: 0 10px 30px rgba(22, 105, 214, 0.08);
  text-align: center;
}

.progress-loader-percent {
  font-size: 28px;
  font-weight: 700;
  color: #0d6efd;
  line-height: 1;
  margin-bottom: 10px;
}

.progress-loader-track {
  width: 100%;
  height: 10px;
  background: #d9e8ff;
  border-radius: 999px;
  overflow: hidden;
}

.progress-loader-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #0d6efd 0%, #4ea1ff 100%);
  transition: width 0.25s ease;
}

.progress-loader-label {
  margin-top: 10px;
  font-size: 13px;
  color: #3d5a80;
}



button {
  padding: 6px 12px;
  cursor: pointer;
}

vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-card {
  background: #fff;
  width: 80%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}
canvas {
  border: 1px solid #ccc;
  cursor: crosshair;
}

.popup-header {
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}


/* Scrollable middle section */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

/* Fixed footer */
.popup-footer {
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  width: 500px;
  align-items: center;
  justify-content: space-between; /* OCR input left, buttons right */
}
.ocr-box {
  flex: 1;
  margin-right: 15px;
}
.chose-font {
 font-size: smaller !important;

}
</style>
